const types = {
    SET_USER_TOKEN: 'SET_USER_TOKEN',
    SET_USER_TYPE: 'SET_USER_TYPE',
    SET_USER_ID: 'SET_USER_ID',
    SET_USER_NAME: 'SET_USER_NAME',
    SET_FIRSTMENU_SELECT: 'SET_FIRSTMENU_SELECT',
    SET_CHILDMENU_SELECT: 'SET_CHILDMENU_SELECT',
    SET_CHILDOPENLIST: 'SET_CHILDOPENLIST',
    SET_CHILDLIST: 'SET_CHILDLIST',
    LOAD_MENUTREE: 'LOAD_MENUTREE',
    SET_COLLAPSED: 'SET_COLLAPSED',
    SET_HOMEPAGE: 'SET_HOMEPAGE',
    SET_BACK_URL:'SET_BACK_URL',
    SET_INDEX_NUM:'SET_INDEX_NUM',
    SET_DEVICE_ID:'SET_DEVICE_ID',
    SET_MONITOR_ACTIVE:'SET_MONITOR_ACTIVE',
    SET_MONITOR_DETAIL_ACTIVE:'SET_MONITOR_DETAIL_ACTIVE',
    SET_DEVICE_DETAIL_ACTIVE:'SET_DEVICE_DETAIL_ACTIVE',
    SET_BASE_IP:'SET_BASE_IP',
    SET_BASE_PORT:'SET_BASE_PORT',
    SET_BASE_PARSE:'SET_BASE_PARSE',
    SER_PASSWORD:'SER_PASSWORD'

}

export default types
